import { render, staticRenderFns } from "./SalonSelect.vue?vue&type=template&id=d6faeeba&scoped=true"
import script from "./SalonSelect.vue?vue&type=script&lang=js"
export * from "./SalonSelect.vue?vue&type=script&lang=js"
import style0 from "./SalonSelect.vue?vue&type=style&index=0&id=d6faeeba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6faeeba",
  null
  
)

export default component.exports